/**
 * @ngdoc services
 * @memberof mercury.modules.settings
 * @name Company
 * @description Data access service for users to manage companies
 */
angular.module('mercury.modules.settings.company')
.factory('LoadedSubscription', ["$http", "$q", "$resource", "settings", function($http, $q, $resource, settings) {
  var Subscriptions = $resource(settings.mercHost + '/subscriptions/:id', {id: '@id'});
  var SubscriptionPreview = $resource(settings.mercHost + '/subscriptions/:id/preview/:plan', {id: '@id', plan: '@plan'});

  /**
   * Get all companies the current user has access to
   *
   * @memberof Company
   */
  function getAll() {
    return Subscriptions.query().$promise;
  }

  function get(id) {
    return Subscriptions.get({id: id}).$promise;
  }

  function preview(id, newPlan) {
    return SubscriptionPreview.get({id: id, plan: newPlan}).$promise;
  }

  function choosePlan(id, planTag) {
    return $http.post(settings.mercHost + '/subscriptions/' + id, '"' + planTag + '"');
  }

  return {
    getAll: getAll,
    get: get,
    preview: preview,
    choosePlan: choosePlan
  };
}]);
